import { render } from "./activities.vue?vue&type=template&id=1917ee56&scoped=true"
import script from "./activities.vue?vue&type=script&lang=js"
export * from "./activities.vue?vue&type=script&lang=js"

import "./activities.vue?vue&type=style&index=0&id=1917ee56&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1917ee56"]])

export default __exports__